import {Col, Row, Typography} from 'antd';
import React from 'react';
import {DesktopOutlined, MobileOutlined, PictureOutlined, TabletOutlined} from '@ant-design/icons';
import ReactCountryFlag from 'react-country-flag';
import {DeviceType, SessionDetails, TraceDetails} from '../api/generated';
import {useCountries} from '../hooks/useCountries';
import {PropertyList} from './PropertyList';
import {LANGUAGES_LIST} from '../lib/languages';

const {Text} = Typography;

const getDeviceType = (traceDetails: TraceDetails | SessionDetails) => {
  if (!traceDetails.deviceType) return null;
  switch (traceDetails.deviceType) {
    case DeviceType.DESKTOP:
      return (
        <Text>
          <DesktopOutlined /> Desktop
        </Text>
      );
    case DeviceType.MOBILE:
      return (
        <Text>
          <MobileOutlined /> Mobile
        </Text>
      );
    case DeviceType.TABLET:
      return (
        <Text>
          <TabletOutlined /> Tablet
        </Text>
      );
    case DeviceType.SMARTTV:
      return (
        <Text>
          <PictureOutlined /> Smart TV
        </Text>
      );
  }
  return null;
};
export const TraceDetailsBlock: React.FC<{traceDetails: TraceDetails | SessionDetails}> = ({
  traceDetails
}) => {
  const {getCountryName} = useCountries();
  const getCountry = (countryCode?: string | null) => {
    if (!countryCode) return null;
    return (
      <>
        <ReactCountryFlag countryCode={countryCode} svg style={{marginRight: 5, marginBottom: 3}} />
        {getCountryName(countryCode)}
      </>
    );
  };
  return (
    <Row>
      <Col span={12}>
        <PropertyList
          omitEmpty
          properties={[
            {label: 'Country', value: getCountry(traceDetails.countryCode)},
            {label: 'IP Address', value: traceDetails.ip},
            {
              label: 'Language',
              value: traceDetails.lang
                ? LANGUAGES_LIST[traceDetails.lang.split('-')[0]]?.name
                : null
            }
          ]}
        />
      </Col>
      <Col span={12}>
        <PropertyList
          omitEmpty
          properties={[
            {label: 'Device type', value: getDeviceType(traceDetails)},
            {
              label: 'Browser',
              value: traceDetails.browser
                ? `${traceDetails.browser} ${traceDetails.browserVersion?.split('.')[0]}`
                : undefined
            },
            {
              label: 'Operation system',
              value: traceDetails.os
                ? `${traceDetails.os} ${traceDetails.osVersion?.split('.')[0]}`
                : undefined
            }
          ]}
        />
      </Col>
    </Row>
  );
};
